/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
var React = require("react");
var IconSVG = /** @class */ (function (_super) {
    tslib_1.__extends(IconSVG, _super);
    function IconSVG() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconSVG.prototype.render = function () {
        return (React.createElement("svg", tslib_1.__assign({ role: "img", viewBox: "0 0 80 80" }, this.props),
            React.createElement("path", { d: "m57.228 38.4090183c.828 0 1.5.671 1.5 1.5v30.626c0 .828-.672 1.5-1.5 1.5h-34.455c-.829 0-1.5-.672-1.5-1.5v-30.626c0-.829.671-1.5 1.5-1.5h11.485 11.485zm-1.5 30.626v-27.626h-8.485v9.985c0 .829-.672 1.5-1.5 1.5h-11.485c-.829 0-1.5-.671-1.5-1.5v-9.985h-8.485v27.626zm-19.97-19.141h8.485v-8.485h-8.485zm38.216-31.174c.613.204 1.026.777 1.026 1.423v7.602c0 .829-.671 1.5-1.5 1.5h-4.59v41.073c0 .828-.672 1.5-1.5 1.5s-1.5-.672-1.5-1.5v-41.073h-51.819v41.073c0 .828-.671 1.5-1.5 1.5-.828 0-1.5-.672-1.5-1.5v-41.073h-4.591c-.828 0-1.5-.671-1.5-1.5v-7.602c0-.66.433-1.243 1.064-1.435l35.022-10.64299998c.299-.091.618-.086.911.012zm-1.974 7.525v-5.02l-30.498-10.151-33.502 10.181v4.99z" })));
    };
    return IconSVG;
}(React.Component));
exports.IconSVG = IconSVG;